import React from 'react';
import { Link, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import './Promotion.scss';

type PromotionProps = {
  originalCity: string;
};

const Promotion = ({ originalCity }: PromotionProps) => {
  const targetUrl = `https://jain-pachkhan-timings.vercel.app/?location=${encodeURIComponent(
    originalCity,
  )}&referrer=pr_pachkhan`;

  const handleClick = () => {
    // Send the user click event to Google Analytics
    gtag('event', 'click', {
      event_category: 'pachkhan_referrer',
      event_label: originalCity,
      event_value: originalCity,
      non_interaction: true,
    });
  };

  return (
    <div className="promotion">
      <Link
        className="link"
        target="_blank"
        href={targetUrl}
        rel="noopener noreferrer"
        onClick={handleClick}
      >
        <Typography variant="h5">
          Do you know Pachkhan timings in {originalCity}?{' '}
          <OpenInNewIcon className="new-page-icon" />
        </Typography>
      </Link>
    </div>
  );
};

export default Promotion;
